import React from 'react';
import { translations } from './translations';

const STORAGE_KEY = 'yk_lang';

const LanguageContext = React.createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = React.useState(() => {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === 'en' || saved === 'ro' ? saved : 'ro';
  });

  React.useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const t = React.useCallback(
    (key) => {
      const parts = String(key).split('.');
      let current = translations[lang];
      for (const part of parts) {
        if (current && Object.prototype.hasOwnProperty.call(current, part)) {
          current = current[part];
        } else {
          return key;
        }
      }
      return current;
    },
    [lang]
  );

  const value = React.useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  const ctx = React.useContext(LanguageContext);
  if (!ctx) throw new Error('useI18n must be used within <LanguageProvider>');
  return ctx;
}
